import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Eye, EyeOff } from "lucide-react";


const StnDisView = () => {
   useAuthRedirect();
    const {stnNo} = useParams();
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const [showLifeDetail, setShowLifeDetail] = useState(false);


  /////////////////////////////////////////////////////////////     
              //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canView  = hasPermission("DisApproved STN Requistion", "view");
              /////////////////////////////////////////////////////////////
         

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        Swal.fire({
                title: "Fetching STN Details",
                html: `
                  <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                    <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                  </div>
                  <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch STN Details...</p>
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                  const style = document.createElement("style");
                  style.innerHTML = `
                    @keyframes progressBar {
                      0% { width: 0% }
                      50% { width: 100% }
                      100% { width: 0% }
                    }
                  `;
                  document.head.appendChild(style);
                },
              });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnDis_detailsHeader?stnNo=${stnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
              stnNumber: items[0].stn_purnumber || "N/A",
              stn_branch: items[0].stn_branch || "N/A",
                stn_now: items[0].stn_now || "N/A",
                stn_dpt: items[0].stn_dpt || "N/A",
                stn_hod: items[0].stn_hod || "N/A",
                stn_requbasis: items[0].stn_requbasis || "N/A",
                stn_headmet: items[0].stn_headmet || "N/A",
                stn_inref: items[0].stn_inref || "N/A",
                stn_remarks: items[0].stn_remarks || "N/A",
            };

            setHeader(storeReqHeader);
            setData(response.data.headerDetails);
        }
        Swal.close();
      } catch (error) {
        Swal.close();
                console.error("Error fetching STN Details. Please try again:", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops!",
                  text: "Error fetching STN Details. Please try again",
                });
      }
    };
{canView && (
    fetchIndentDetails()
)}
  }, [stnNo]); 


if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                        <h2 className="add-txt">STN - Dis Approved View</h2>
                        <Link to={`/inventory/stn_disApprovalview`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                      </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>STN Req No :</label>
                <input type="text" name="indentNo" value={header.stnNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text"
                value={header.stn_now ? new Date(header.stn_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>To Branch :</label>
                <input type="text" name="type" value={header.stn_branch} readOnly />
              </div>
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="branch" value={header.stn_dpt} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={header.stn_hod} readOnly/>
              </div>

              <div className="form-group">
                <label>Head Meterial:</label>
                <input type="text"value={header.stn_headmet} readOnly />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Req Basis :</label>
                <input type="text" value={header.stn_requbasis} readOnly/>
              </div>

              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" value={header.stn_inref} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.stn_remarks} readOnly/>
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>
            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                     {showLifeDetail && (
                      <th style={{ textAlign: "center" }}>
                        Life Detail
                      </th>
                    )}
                    <th>
                      <button
                        type="button"
                        onClick={() => setShowLifeDetail(!showLifeDetail)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.stn_itemcode}</td>
                        <td>{item.stn_drawno}</td>
                        <td>{item.stn_desc}</td>
                        <td>{item.stn_uom}</td>
                        <td>{item.stn_price}</td>
                        <td>{item.stn_qty}</td>
                        <td>{item.stn_duedate ? new Date(item.stn_duedate).toISOString().split("T")[0] : ""}</td>
                        <td>{item.stn_specification}</td>
                        <td>{item.stn_purpose}</td>
                                                  {showLifeDetail && (
 <td>{item.stn_lifetime}</td>
                )}
                        
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default StnDisView;
